export const KEY_COPY_STRING = '-0-0-0-0-0-';
export const CODE_COPY_STRING = '000000';
export const CURVE_COPY_NUMBER = 100000;
export const DEFAULT_STEP = 10;
export const SCALE_TITLES = ['1 масштаб', '2 масштаб', '3 масштаб'];
export const SCALE_INPUTS_TITLES = [
    { title: 'Min', purpose: 'min', curveProp: 'xStart' },
    { title: 'Шаг', purpose: 'step', curveProp: 'xStep' },
    { title: 'Max', purpose: 'max', curveProp: 'xStop' },
];
